import { render, staticRenderFns } from "./BMenuGroupDetail.vue?vue&type=template&id=bbe08924&scoped=true&"
import script from "./BMenuGroupDetail.vue?vue&type=script&lang=js&"
export * from "./BMenuGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./BMenuGroupDetail.vue?vue&type=style&index=0&id=bbe08924&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe08924",
  null
  
)

export default component.exports